import { type FC } from 'react';
import { useBoostFirebaseEvents } from '@common/hooks/boost-firebase-events';
import { WorkshopActiveBoostItem } from '@components/ActiveBoostItem/WorkshopActiveBoostItem/WorkshopActiveBoostItem';
import { BoostCard } from '@components/BoostCard/BoostCard';
import { BoostFirebaseEventsContext } from '@context/BoostFirebaseEventContext';
import { useModal } from '@context/ModalContext';
import {
  selectActiveBoostForWorkshop,
  selectFreeBoostForWorkshop,
  selectVipBoostForWorkshop,
  selectWorkshopBoostList,
  selectWorkshopList,
} from '@redux/selectors/workshopSelectors';
import { useAppSelector } from '@redux/store';

import PlantBoostModal from '../PlantBoostModal';

const WorkshopBoostModal: FC = () => {
  const activeBoosts = useAppSelector(selectWorkshopBoostList);
  const { isGoodsBoostModalOpen, setIsGoodsBoostModalOpen } = useModal();
  const freeBoost = useAppSelector((state) =>
    selectFreeBoostForWorkshop(state),
  );
  const vipBoost = useAppSelector((state) => selectVipBoostForWorkshop(state));
  const workshopList = useAppSelector(selectWorkshopList);
  const activeBoost = useAppSelector(selectActiveBoostForWorkshop);
  const events = useBoostFirebaseEvents({}, activeBoost, workshopList);

  return (
    <BoostFirebaseEventsContext.Provider value={events}>
      <PlantBoostModal
        plantType="Workshop"
        activeBoostList={activeBoosts}
        activeBoostItem={(props) => (
          <WorkshopActiveBoostItem key={props.id} {...props} />
        )}
        boostCardList={[freeBoost, vipBoost].map((boost) => ({
          ...boost,
          variant: 'big',
          plantType: 'Workshop',
        }))}
        boostCardItem={(props) => (
          <BoostCard key={props.boostType} {...props} />
        )}
        isPlantBoostOpen={isGoodsBoostModalOpen}
        setOpenPlantBoostModal={setIsGoodsBoostModalOpen}
      />
    </BoostFirebaseEventsContext.Provider>
  );
};

export { WorkshopBoostModal };
